import { FormInstance } from "antd";
import { FC } from "react";
import { Form, FORM_FIELD_TYPES } from "site/ui";
import { ICourse } from "utils/types";

export interface AdditionalInfoProps {
    formRef: React.RefObject<FormInstance<ICourse>>
    course?: ICourse;
    setCourseChanges?: (func: (courseChanges: Partial<ICourse>) => Partial<ICourse>) => void;
}
export const AdditionalInfo:FC<AdditionalInfoProps> = ({
    formRef, course, setCourseChanges
}) => {

    return (
        <Form

            formRef={formRef}
            formProps={{
                layout: "vertical",
                initialValues: course,
                onValuesChange(changedValues) {
                    setCourseChanges?.(prev => ({...prev, ...changedValues}))
                },
            }}
            items={[
                {
                fieldType: FORM_FIELD_TYPES.TEXT_AREA,
                itemProps: {
                    name: "learningObjectives",
                    label: "Learning objectives",
                },
                fieldProps: {
                    placeholder: "Enter learning objectives",
                    rows: 4,
                },
                },
                {
                fieldType: FORM_FIELD_TYPES.TEXT_AREA,
                itemProps: {
                    name: "targetAudience",
                    label: "Target audience",
                },
                fieldProps: {
                    placeholder: "Describe who this course is for",
                    rows: 4,
                },
                },
                {
                fieldType: FORM_FIELD_TYPES.TEXT_AREA,
                itemProps: {
                    name: "prerequisites",
                    label: "Prerequisites",
                },
                fieldProps: {
                    placeholder: "List any prerequisites for this course",
                    rows: 4,
                },
                },
            ]}
        />
    )
}